'use client'

import { ArticlePreview } from '@/components/common/ArticlePreview'
import { ButtonImage, ButtonText } from '@/components/common/Button'
import { NoResults } from '@/components/common/NoResults'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { usePage } from '@/components/providers/PageProvider'
import { CARDART } from '@/defs/misc'
import { WORDPRESS_CATEGORY_LABELS, WORDPRESS_CATEGORY_SLUGS_MAIN } from '@/defs/wordpress'
import { buildRoute } from '@/utils/routeUtil'

import styles from './HomeTopArticles.module.scss'

export const HomeTopArticles = () => {
  const { page } = usePage()

  const articles = page?.home?.articles || []

  return (
    <div className={styles.container}>
      {articles.length < 1 ? (
        <NoResults message='No articles found!' size='lg' />
      ) : (
        <ul className={styles.articles}>
          {articles.slice(0, 7).map((article, i) => (
            <li key={i}>
              <ArticlePreview
                article={article}
                hideExcerpt={i > 0}
                isAboveFold={i === 0}
                layout={i === 0 ? 'vertical' : undefined}
                layoutLg={i === 1 || i === 2 ? 'vertical' : undefined}
                showCategory
                size={i === 0 ? 'lg' : undefined}
              />
            </li>
          ))}
        </ul>
      )}
      <div className={styles.more}>
        <ButtonText as='LinkRoute' href={buildRoute({ section: 'articlesLanding' })} size='lg' underlined>
          <IconWithLabel iconAfter='caretRight'>More</IconWithLabel>
        </ButtonText>
      </div>
      <h2 className={styles.heading}>Browse Articles by Category</h2>
      <ul className={styles.categories}>
        {WORDPRESS_CATEGORY_SLUGS_MAIN.map((slug, i) => (
          <li key={i}>
            <ButtonImage
              as='LinkRoute'
              href={buildRoute({ articleCategorySlug: slug, section: 'articlesCategory' })}
              image={WORDPRESS_CATEGORY_LABELS[slug].imageArt}
              label={WORDPRESS_CATEGORY_LABELS[slug].label}
              nowrap
              size='lg'
            >
              {WORDPRESS_CATEGORY_LABELS[slug].label}
            </ButtonImage>
          </li>
        ))}
        <li>
          <ButtonImage
            as='LinkRoute'
            href={buildRoute({ section: 'articlesLanding' })}
            image={CARDART.AD_NAUSEAM}
            label='All Articles'
            nowrap
            size='lg'
          >
            All Articles
          </ButtonImage>
        </li>
      </ul>
    </div>
  )
}
